var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"my-app home-two-dark"},[_c('Header2',{staticClass:"header--dark"}),_c('MobileMenu'),_c('div',{staticClass:"mobile-menu__backdrop"}),_c('Banner'),_c('Generate'),_c('About'),_c('Publish'),_c('Tour'),_c('Pricing'),_c('Testimonials'),_c('hr',{attrs:{"id":"horizon-break"}}),_c('FAQ'),_c('Footer2')],1),_c('BackToTop')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }